import { axios, def, handleError } from './internal';

function AdminCacheStats(setData, hours = 24) {
    setData((prev) => ({ ...prev, loading: true }));
    axios
        .post('/api/admin_cache_stats', { hours })
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) {
                setData({ loading: false, rows: res.data.data?.rows ?? [], enabled: res.data.data?.enabled === true });
            } else {
                setData((prev) => ({ ...prev, loading: false }));
            }
        })
        .catch((err) => {
            setData((prev) => ({ ...prev, loading: false }));
            handleError(err);
        });
}

// action: 'start' (clears the old stats, turns the measurement on) | 'stop'
function AdminCacheStatsControl(action, onSuccess) {
    axios
        .post('/api/admin_cache_stats_control', { action })
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) onSuccess?.(res.data.data.enabled);
        })
        .catch(handleError);
}

export { AdminCacheStats, AdminCacheStatsControl };
